import * as React from 'react'
import cn from 'classnames'

type StepDotsProps = {
  totalSteps: number
  currentStep: number
}

// Progress indicator in the modal footer: active step = wide green pill, the rest
// muted dots.
export const StepDots = ({ totalSteps, currentStep }: StepDotsProps) => (
  <div className="flex items-center gap-2">
    {Array.from({ length: totalSteps }, (_, index) => {
      const isActive = index + 1 === currentStep

      return (
        <span
          key={index}
          className={cn(
            'h-1.5 rounded-full transition-all',
            isActive ? 'w-4 bg-[#2E9E5D]' : 'w-1.5 bg-[#D7DBE8]',
          )}
        />
      )
    })}
  </div>
)
